import Box from "./Box";
import React, { useState, useEffect } from 'react';
import CustomSingleSelect, { CustomSingleSelectModel } from "./CustomSingleSelect";
import { useDispatch } from "react-redux";
import { storeActivityIndicator, storeFastFirm } from "../redux/reducers/authSlice";
import toast from "react-hot-toast";
import { ConstantService } from "../services/ConstantService";
import { Helpers } from "../helpers/Helpers";
import { useMask } from "@react-input/mask";
import CustomMultiSelect, { CustomMultiSelectModel } from "./CustomMultiSelect";
import { GetCompanyByIdResponse, GetCompanyByIdResponseCompanyAddress } from "../models/response/company/GetCompanyByIdResponse";
import { CompanyService } from "../services/CompanyService";
import { AddCompanyRequest } from "../models/request/company/AddCompanyRequest";
import { AddCompanyResponse, AddCompanyResponseData } from "../models/response/company/AddCompanyResponse";
import { AddCompanyAddressRequest } from "../models/request/companyAddress/AddCompanyAddressRequest";
import { CompanyAddressService } from "../services/CompanyAddressService";
import { AddCompanyAddressResponse } from "../models/response/companyAddress/AddCompanyAddressResponse";
import { GetCompanyAddressByCountryIdAndPostalCodeResponse } from "../models/response/companyAddress/GetCompanyAddressByCountryIdAndPostalCodeResponse";
import { GetConstantListResponse } from "../models/response/constant/GetConstantListResponse";
import { MeetingCompanyTypeEnum } from "../models/common/Enums";
import { CountryService } from "../services/CountryService";

export enum FastFirmFields {
    FirmName,
    AddressType,
    AddressText,
    Country,
    PostalCode,
    County,
    District,
    AuthorizedPerson,
    FirmType,
    InitialCompanyType,
    /** Semt kutusu; ilçeye bağlı doldurulur. Enum sonuna eklendi ki mevcut alanların sayısal değerleri kaymasın. */
    Neighborhood
}

export interface FastFirmProps {
    companyId?: string | undefined
    addressTypeId?: string | undefined
    isJustAddress?: boolean
    isCustomer?: boolean
    isSupplier?: boolean
    isAgency?: boolean
    isSenderFirm?: boolean
    isReceiverFirm?: boolean
    isDutyFirm?: boolean
    isAirlineFirm?: boolean
    isSeawayFirm?: boolean
    isCompany?: boolean
    isRepresentative?: boolean
    allowedFields?: FastFirmFields[]
    onSubmit: (response: AddCompanyResponseData) => void
    defaultInitialCompanyTypeId?: string | undefined
    /** Verilirse başlıkta "Firma tanımlı" düğmesi çıkar: firma oluşturmadan sonraki adıma geçilir (firma orada seçilir). */
    onFirmaTanimli?: () => void
}

const FastFirm = ({
    companyId,
    isAgency,
    isAirlineFirm,
    isCompany,
    isRepresentative,
    isCustomer,
    isDutyFirm,
    isReceiverFirm,
    isSeawayFirm,
    isSenderFirm,
    isSupplier,
    onSubmit,
    addressTypeId,
    isJustAddress,
    allowedFields,
    defaultInitialCompanyTypeId,
    onFirmaTanimli
}: FastFirmProps) => {
    const dispatch = useDispatch();
    const [authPersonId, setAuthPersonId] = useState<string | undefined>(undefined);
    const [companyAddressId, setCompanyAddressId] = useState<string | undefined>(undefined);
    const [name, setName] = useState<string | undefined>(undefined);
    const [selectedAddressType, setSelectedAddressType] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [addressText, setAddressText] = useState<string | undefined>(undefined);
    const [selectedCountry, setSelectedCountry] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedCounty, setSelectedCounty] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedDistrict, setSelectedDistrict] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedNeighborhood, setSelectedNeighborhood] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [postalCode, setPostalCode] = useState<string | undefined>(undefined);
    const [authPersonName, setAuthPersonName] = useState<string | undefined>(undefined);
    const [authPersonSurname, setAuthPersonSurname] = useState<string | undefined>(undefined);
    const [authPersonPhone1, setAuthPersonPhone1] = useState<string | undefined>(undefined);
    const [authPersonEmail, setAuthPersonEmail] = useState<string | undefined>(undefined);
    const authPersonPhone1Ref = useMask({ mask: '(___) ___-__-__', replacement: { _: /\d/ } });
    const [isDefault, setIsDefault] = useState(true);
    const [code, setCode] = useState<string | undefined>(undefined);
    const [selectedFirmTypes, setSelectedFirmTypes] = useState<CustomMultiSelectModel[]>([
        isCustomer ? { label: 'Müşteri', value: 'isCustomer' } : { label: '', value: '' },
        isSupplier ? { label: 'Tedarikçi', value: 'isSupplier' } : { label: '', value: '' },
        isAgency ? { label: 'Acente', value: 'isAgency' } : { label: '', value: '' },
        isSenderFirm ? { label: 'Gönderici Firma', value: 'isSenderFirm' } : { label: '', value: '' },
        isReceiverFirm ? { label: 'Alıcı Firma', value: 'isReceiverFirm' } : { label: '', value: '' },
        isDutyFirm ? { label: 'Gümrük Firması', value: 'isDutyFirm' } : { label: '', value: '' },
        isAirlineFirm ? { label: 'Havayolu', value: 'isAirlineFirm' } : { label: '', value: '' },
        isSeawayFirm ? { label: 'Denizyolu', value: 'isSeawayFirm' } : { label: '', value: '' },
        // isCompany ? { label: 'Şirket', value: 'isCompany' } : { label: '', value: '' },
        isRepresentative ? { label: 'Mümessil', value: 'isRepresentative' } : { label: '', value: '' },
    ].filter(x => x.label != '' && x.value != ''));
    const [selectedInitialCompanyType, setSelectedInitialCompanyType] = useState<CustomSingleSelectModel | undefined>(undefined);
    useEffect(() => {
        getData();
    }, [])

    const saveCompany = async () => {
        try {
            if (Helpers.isEmpty(name))
                toast.error('Firma alanını doldurunuz!')
            else if ((!allowedFields || allowedFields.includes(FastFirmFields.AddressType)) && !selectedAddressType)
                toast.error('Adres Türü alanını doldurunuz!')
            else if ((!allowedFields || allowedFields.includes(FastFirmFields.AddressText)) && Helpers.isEmpty(addressText))
                toast.error('Açık Adres alanını doldurunuz!')
            // else if ((!allowedFields || allowedFields.includes(FastFirmFields.Country)) && !selectedCountry)
            //     toast.error('Ülke alanını doldurunuz!')
            // else if ((!allowedFields || allowedFields.includes(FastFirmFields.PostalCode)) && Helpers.isEmpty(postalCode))
            //     toast.error('Posta Kodu alanını doldurunuz!')
            // else if ((!allowedFields || allowedFields.includes(FastFirmFields.County)) && !selectedCounty)
            //     toast.error('Şehir alanını doldurunuz!')
            // else if ((!allowedFields || allowedFields.includes(FastFirmFields.District)) && !selectedDistrict)
            //     toast.error('İlçe alanını doldurunuz!')
            else if (!selectedFirmTypes || selectedFirmTypes.length == 0)
                toast.error('Firma Türü alanını doldurunuz!')
            else if ((!Helpers.isEmpty(authPersonPhone1) && authPersonPhone1 && authPersonPhone1.length < 15))
                toast.error('Lütfen geçerli bir telefon numarası giriniz!')
            else if ((!Helpers.isEmpty(authPersonEmail) && authPersonEmail && !Helpers.validateEmail(authPersonEmail)))
                toast.error('Lütfen geçerli bir email adresi giriniz!')
            else if ((!allowedFields || allowedFields.includes(FastFirmFields.InitialCompanyType)) && !selectedInitialCompanyType)
                toast.error('Firma Durumu alanını doldurunuz!')
            else {
                dispatch(storeActivityIndicator(true));

                var obj: AddCompanyRequest = {
                    initialCompanyTypeId: selectedInitialCompanyType?.value,
                    companyId: companyId,
                    name: name,
                    companyAddresses: Helpers.isEmpty(addressText) ? [] : [{
                        addressText: addressText,
                        districtId: selectedDistrict?.value,
                        addressTypeId: selectedAddressType?.value,
                        isCustomActive: 1,
                        isDefault: isDefault ? 1 : 0,
                        postalCode: postalCode,
                        neighborhoodId: selectedNeighborhood?.value,
                    }],
                    companyAuthorizedPersons: (!Helpers.isEmpty(authPersonName) || !Helpers.isEmpty(authPersonSurname) || !Helpers.isEmpty(authPersonPhone1))
                        ?
                        [{
                            departmentId: undefined,
                            description: undefined,
                            isCustomActive: 1,
                            name: authPersonName,
                            phone1: authPersonPhone1,
                            phone2: undefined,
                            surname: authPersonSurname,
                            email: authPersonEmail
                        }] : [],
                    isCustomer: isCustomer ? 1 : 0,
                    isSupplier: isSupplier ? 1 : 0,
                    isAgency: isAgency ? 1 : 0,
                    isSenderFirm: isSenderFirm ? 1 : 0,
                    isReceiverFirm: isReceiverFirm ? 1 : 0,
                    isDutyFirm: isDutyFirm ? 1 : 0,
                    isAirlineFirm: isAirlineFirm ? 1 : 0,
                    isSeawayFirm: isSeawayFirm ? 1 : 0,
                    isCompany: isCompany ? 1 : 0,
                    isRepresentative: isRepresentative ? 1 : 0,
                    abnNumber: undefined,
                    mernisNo: undefined,
                    agencyIntegrationCode: undefined,
                    blockedDescription: undefined,
                    code: code,
                    commercialTypeId: undefined,
                    companyBanks: [],
                    companyLogo: undefined,
                    customerIntegrationCode: undefined,
                    description: undefined,
                    eArchiveSendTypeId: undefined,
                    eArchiveTypeId: undefined,
                    email: undefined,
                    fileArchives: [],
                    invoiceCurrencyTypeId: undefined,
                    isBlocked: 0,
                    isCustomActive: 1,
                    logo: undefined,
                    longName: name,
                    maturityPeriodId: undefined,
                    paymentTypeId: undefined,
                    phone1: undefined,
                    supplierIntegrationCode: undefined,
                    taxOffice: undefined,
                    tckn: undefined,
                    vkn: undefined,
                    receiverFirmIntegrationCode: undefined,
                    senderFirmIntegrationCode: undefined,
                    isWithholding: 0
                }

                var response: AddCompanyResponse = await CompanyService.addCompany(obj);

                if (!response.isSuccess) {
                    toast.error(response.message);
                    dispatch(storeActivityIndicator(false));
                    return;
                }

                dispatch(storeFastFirm(undefined));

                toast.success(response.message)

                onSubmit(response.data);
            }
        } catch (error: any) {
            toast.error(error);
        }
        finally {
            dispatch(storeActivityIndicator(false));
        }
    }

    const getCompanyAddressByCountryIdAndPostalCode = async (_selectedCountry: CustomSingleSelectModel | undefined, _postalCode: string | undefined) => {
        try {
            if (_selectedCountry && _postalCode && !Helpers.isEmpty(_postalCode)) {
                dispatch(storeActivityIndicator(true));

                var response: GetCompanyAddressByCountryIdAndPostalCodeResponse = await CompanyAddressService.getCompanyAddressByCountryIdAndPostalCode(_selectedCountry.value, _postalCode);

                if (!response.isSuccess) {
                    toast.error(response.message);
                    dispatch(storeActivityIndicator(false));
                    return;
                }

                if (response.data) {
                    if (response.data.countyId && response.data.countyName)
                        setSelectedCounty({ label: response.data.countyName, value: response.data.countyId })

                    if (response.data.districtId && response.data.districtName)
                        setSelectedDistrict({ label: response.data.districtName, value: response.data.districtId })
                }
                else {
                    setSelectedCounty(undefined)
                    setSelectedDistrict(undefined);
                    setSelectedNeighborhood(undefined);
                }
            }
        } catch (error: any) {
            toast.error(error);
        }
        finally {
            dispatch(storeActivityIndicator(false));
        }
    }

    const saveCompanyAddress = async () => {
        try {
            if (!selectedAddressType)
                toast.error('Adres Türü alanını doldurunuz!')
            else if (Helpers.isEmpty(addressText))
                toast.error('Açık Adres alanını doldurunuz!')
            else if (!selectedCountry)
                toast.error('Ülke alanını doldurunuz!')
            else if (Helpers.isEmpty(postalCode))
                toast.error('Posta Kodu alanını doldurunuz!')
            else if (!selectedCounty)
                toast.error('Şehir alanını doldurunuz!')
            else if (!selectedDistrict)
                toast.error('İlçe alanını doldurunuz!')
            else {
                dispatch(storeActivityIndicator(true));

                var obj: AddCompanyAddressRequest = {
                    addressText: addressText,
                    districtId: selectedDistrict.value,
                    neighborhoodId: selectedNeighborhood?.value,
                    addressTypeId: selectedAddressType.value,
                    isCustomActive: 1,
                    isDefault: isDefault ? 1 : 0,
                    postalCode: postalCode,
                    companyAddressId: companyAddressId,
                    companyId: companyId
                }

                var response: AddCompanyAddressResponse = await CompanyAddressService.addCompanyAddress(obj);

                if (!response.isSuccess) {
                    toast.error(response.message);
                    dispatch(storeActivityIndicator(false));
                    return;
                }

                dispatch(storeFastFirm(undefined));

                toast.success(response.message)

                onSubmit({
                    blockedDescription: undefined,
                    code: '',
                    companyId: companyId + '',
                    createdDate: '',
                    createdUser: '',
                    description: undefined,
                    email: undefined,
                    isBlocked: false,
                    isCustomActive: false,
                    logo: '',
                    longName: '',
                    name: '',
                    parentCompanyId: '',
                    phone1: undefined,
                    updatedDate: '',
                    updatedUser: '',
                    companyAddresses: [response.data]
                });
            }
        } catch (error: any) {
            toast.error(error);
            dispatch(storeActivityIndicator(false));
        }
    }

    const getData = async (_id: string | undefined | null = undefined) => {
        try {
            dispatch(storeActivityIndicator(true));

            if (companyId && !Helpers.isEmpty(companyId)) {
                var response: GetCompanyByIdResponse = await CompanyService.getCompanyById(companyId);

                if (!response.isSuccess) {
                    toast.error(response.message)
                    return;
                }

                setCode(response.data.code);
                setName(response.data.name);

                if (response.data.companyAddresses.length > 0) {
                    var companyAddress: GetCompanyByIdResponseCompanyAddress | undefined = undefined;

                    if (addressTypeId)
                        companyAddress = response.data.companyAddresses.find(x => x.addressTypeId == addressTypeId);

                    if (!companyAddress && !isJustAddress)
                        companyAddress = response.data.companyAddresses.find(x => x.isDefault);

                    if (!companyAddress && !isJustAddress)
                        companyAddress = response.data.companyAddresses[0];

                    if (companyAddress) {
                        if (addressTypeId)
                            setIsDefault(companyAddress.isDefault)

                        setCompanyAddressId(companyAddress.companyAddressId);

                        if (companyAddress.addressTypeId && companyAddress.addressTypeName)
                            setSelectedAddressType({ label: companyAddress.addressTypeName, value: companyAddress.addressTypeId });

                        if (companyAddress.addressText)
                            setAddressText(companyAddress.addressText);

                        if (companyAddress.countryId && companyAddress.countryName) {
                            setSelectedCountry({ label: companyAddress.countryName, value: companyAddress.countryId });
                        }

                        if (companyAddress.countyId && companyAddress.countyName) {
                            setSelectedCounty({ label: companyAddress.countyName, value: companyAddress.countyId });
                        }

                        if (companyAddress.districtId && companyAddress.districtName)
                            setSelectedDistrict({ label: companyAddress.districtName, value: companyAddress.districtId });

                        if (companyAddress.neighborhoodId && companyAddress.neighborhoodName)
                            setSelectedNeighborhood({ label: companyAddress.neighborhoodName, value: companyAddress.neighborhoodId });

                        setPostalCode(companyAddress.postalCode);
                    }
                }

                if (response.data.companyAuthorizedPersons.length > 0) {
                    var authorizedPerson = response.data.companyAuthorizedPersons[0];

                    setAuthPersonId(authorizedPerson.companyAuthorizedPersonId);
                    setAuthPersonName(authorizedPerson.name);
                    setAuthPersonSurname(authorizedPerson.surname);
                    setAuthPersonPhone1(authorizedPerson.phone1);
                    setAuthPersonEmail(authorizedPerson.email);
                }

                if (response.data.initialCompanyTypeId)
                    setSelectedInitialCompanyType({ label: response.data.initialCompanyTypeName, value: response.data.initialCompanyTypeId });
            }
            else {
                var response5: GetConstantListResponse = await ConstantService.getConstantList('MEETING_COMPANY_TYPE', undefined, (defaultInitialCompanyTypeId ? defaultInitialCompanyTypeId : MeetingCompanyTypeEnum.CALISILAN_MUSTERI));

                if (!response5.isSuccess) {
                    toast.error(response5.message)
                    return;
                }

                if (response5.data.length > 0) {
                    setSelectedInitialCompanyType({ label: response5.data[0].value + '', value: response5.data[0].constantId, additionalValue1: response5.data[0].additionalValue1 });
                }
            }
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    return (
        <div style={{ position: 'fixed', top: 0, right: 0, background: 'rgba(0, 0, 0, 0.66)', zIndex: 999, width: '100%', height: '100%' }}>
            <Box width="100%" height="100%" flexDirection="row">
                <Box onClick={() => dispatch(storeFastFirm(undefined))} flexGrow={1}>
                    &nbsp;
                </Box>
                <Box width="400px" height="100%" alignSelf="flex-end" bg='white'>
                    <Box className="mb-10" flexDirection="row" pl="15px" pr="15px" pt="15px">
                        <Box flexGrow={1} justifyContent="center">
                            <h4 className="m-0 text-black">Hızlı Firma İşlemleri</h4>
                        </Box>
                        {
                            onFirmaTanimli && (
                                <Box justifyContent="center" mr="12px">
                                    <button
                                        type="button"
                                        title="Firma zaten tanımlıysa yeni firma açmadan sürücü adımına geçer; firma orada seçilir"
                                        className="btn btn-sm btn-light-primary fw-bold"
                                        onClick={() => {
                                            dispatch(storeFastFirm(undefined));
                                            onFirmaTanimli();
                                        }}
                                    >
                                        Firma tanımlı
                                    </button>
                                </Box>
                            )
                        }
                        <Box justifyContent="center">
                            <i onClick={() => dispatch(storeFastFirm(undefined))} style={{ fontSize: 18 }} className="actionIcon text-muted fa fa-times" />
                        </Box>
                    </Box>

                    <Box overflowY="auto" pl="15px" pr="15px">
                        {
                            (!allowedFields || allowedFields.includes(FastFirmFields.FirmName)) && (
                                <div>
                                    <label htmlFor="exampleFormControlInput1" className="form-label required">Firma</label>
                                    <input disabled={isJustAddress} style={{ border: '1px solid #F1F1F4' }} value={name} onChange={(e) => setName(e.target.value)} type="text" className="form-control form-control-solid" />
                                </div>
                            )
                        }

                        {
                            (!allowedFields || allowedFields.includes(FastFirmFields.AddressType)) && (
                                <div className="mt-5">
                                    <label htmlFor="exampleFormControlInput1" className="form-label required">Adres Türü</label>

                                    <CustomSingleSelect
                                        selectedValue={selectedAddressType}
                                        onChange={setSelectedAddressType}
                                        insertable={{
                                            onSubmit: { code: 'COMPANY_ADDRESS_TYPE' }
                                        }}
                                        onMenuOpen={() => ConstantService.getConstantList('COMPANY_ADDRESS_TYPE')}
                                        labelName='value'
                                        valueName='constantId'
                                    />
                                </div>
                            )
                        }

                        {
                            (!allowedFields || allowedFields.includes(FastFirmFields.AddressText)) && (
                                <div className="mt-5">
                                    <label htmlFor="exampleFormControlInput1" className="form-label required">Açık Adres</label>
                                    <textarea value={addressText} onChange={(e) => setAddressText(e.target.value)} style={{ border: '1px solid #F1F1F4', width: '100%', height: 100, resize: 'none' }} className="form-control form-control-solid" />
                                </div>
                            )
                        }

                        {
                            (!allowedFields || allowedFields.includes(FastFirmFields.Country)) && (
                                <div className="mt-5">
                                    <label htmlFor="exampleFormControlInput1" className="form-label">Ülke</label>

                                    <CustomSingleSelect
                                        selectedValue={selectedCountry}
                                        onChange={(selectedItem) => {
                                            setSelectedCountry(selectedItem);
                                            setSelectedCounty(undefined);
                                            setSelectedDistrict(undefined);
                                            getCompanyAddressByCountryIdAndPostalCode(selectedItem, postalCode);
                                        }}
                                        onMenuOpen={() => CountryService.getCountryList()}
                                        labelName='name'
                                        valueName='countryId'
                                    />
                                </div>

                            )
                        }

                        {
                            (!allowedFields || allowedFields.includes(FastFirmFields.PostalCode)) && (
                                <div className="mt-5">
                                    <label htmlFor="exampleFormControlInput1" className="form-label">Posta Kodu</label>
                                    <input onBlur={() => getCompanyAddressByCountryIdAndPostalCode(selectedCountry, postalCode)} value={postalCode} onChange={(e) => setPostalCode(e.target.value)} style={{ border: '1px solid #F1F1F4' }} type={'text'} className="form-control form-control-solid" />
                                </div>
                            )
                        }

                        {
                            (!allowedFields || allowedFields.includes(FastFirmFields.County)) && (
                                < div className="mt-5" >
                                    <label htmlFor="exampleFormControlInput1" className="form-label">Şehir</label>

                                    <CustomSingleSelect
                                        selectedValue={selectedCounty}
                                        onChange={(selectedItem) => {
                                            setSelectedCounty(selectedItem);
                                            setSelectedDistrict(undefined);
                                            setSelectedNeighborhood(undefined);
                                        }}
                                        onMenuOpen={selectedCountry ? () => ConstantService.getConstantList('COUNTY', selectedCountry.value) : undefined}
                                        labelName='value'
                                        valueName='constantId'
                                    />
                                </div>
                            )
                        }

                        {
                            (!allowedFields || allowedFields.includes(FastFirmFields.District)) && (
                                <div className="mt-5">
                                    <label htmlFor="exampleFormControlInput1" className="form-label">İlçe</label>

                                    <CustomSingleSelect
                                        selectedValue={selectedDistrict}
                                        onChange={(selectedItem) => {
                                            setSelectedDistrict(selectedItem);
                                            setSelectedNeighborhood(undefined);
                                        }}
                                        onMenuOpen={selectedCounty ? () => ConstantService.getConstantList('DISTRICT', selectedCounty.value) : undefined}
                                        labelName='value'
                                        valueName='constantId'
                                    />
                                </div>
                            )
                        }

                        {
                            (!allowedFields || allowedFields.includes(FastFirmFields.Neighborhood)) && (
                                <div className="mt-5">
                                    <label htmlFor="exampleFormControlInput1" className="form-label">Semt</label>

                                    {/* Semt listesi seçili ilçeye bağlı; ilçe seçilmeden kutu açılmaz. */}
                                    <CustomSingleSelect
                                        selectedValue={selectedNeighborhood}
                                        onChange={setSelectedNeighborhood}
                                        onMenuOpen={selectedDistrict ? () => ConstantService.getConstantList('NEIGHBORHOOD', selectedDistrict.value) : undefined}
                                        labelName='value'
                                        valueName='constantId'
                                    />
                                </div>
                            )
                        }

                        {
                            (!allowedFields || allowedFields.includes(FastFirmFields.AuthorizedPerson)) && (
                                <React.Fragment>
                                    <div className="mt-5">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Yetkili Ad</label>
                                        <input disabled={isJustAddress} value={authPersonName} onChange={(e) => setAuthPersonName(e.target.value)} style={{ border: '1px solid #F1F1F4' }} type={'text'} className="form-control form-control-solid" />
                                    </div>

                                    <div className="mt-5">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Yetkili Soyad</label>
                                        <input disabled={isJustAddress} value={authPersonSurname} onChange={(e) => setAuthPersonSurname(e.target.value)} style={{ border: '1px solid #F1F1F4' }} type={'text'} className="form-control form-control-solid" />
                                    </div>

                                    <div className="mt-5">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Yetkili Telefon</label>
                                        <input disabled={isJustAddress} ref={authPersonPhone1Ref} style={{ border: '1px solid #F1F1F4' }} value={authPersonPhone1} onChange={(e) => setAuthPersonPhone1(e.target.value)} className="form-control form-control-solid" />
                                    </div>

                                    <div className="mt-5">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Yetkili E-Posta</label>
                                        <input style={{ border: '1px solid #F1F1F4' }} value={authPersonEmail} onChange={(e) => setAuthPersonEmail(e.target.value)} type="text" className="form-control form-control-solid" />
                                    </div>
                                </React.Fragment>
                            )
                        }

                        {
                            (!allowedFields || allowedFields.includes(FastFirmFields.FirmType)) && (
                                <div className="mt-5">
                                    <label htmlFor="exampleFormControlInput1" className="form-label required">Firma Türü</label>

                                    <div>
                                        <CustomMultiSelect
                                            disabled={isJustAddress}
                                            onChange={setSelectedFirmTypes}
                                            selectedValues={selectedFirmTypes}
                                            onMenuOpen={async () => {
                                                return {
                                                    isSuccess: true,
                                                    data: [
                                                        { label: 'Müşteri', value: 'isCustomer' },
                                                        { label: 'Tedarikçi', value: 'isSupplier' },
                                                        { label: 'Acente', value: 'isAgency' },
                                                        { label: 'Gönderici Firma', value: 'isSenderFirm' },
                                                        { label: 'Alıcı Firma', value: 'isReceiverFirm' },
                                                        { label: 'Gümrük Firması', value: 'isDutyFirm' },
                                                        { label: 'Havayolu', value: 'isAirlineFirm' },
                                                        { label: 'Denizyolu', value: 'isSeawayFirm' },
                                                        { label: 'Mümessil', value: 'isRepresentative' },
                                                        // { label: 'Şirket', value: 'isCompany' },
                                                    ]
                                                }
                                            }}
                                            labelName='label'
                                            valueName='value'
                                        />
                                    </div>
                                </div>
                            )
                        }


                        {
                            (!allowedFields || allowedFields.includes(FastFirmFields.InitialCompanyType)) && (
                                <div className="mt-5">
                                    <label htmlFor="exampleFormControlInput1" className="form-label required">Firma Durumu</label>
                                    <CustomSingleSelect
                                        selectedValue={selectedInitialCompanyType}
                                        onChange={setSelectedInitialCompanyType}
                                        onMenuOpen={() => ConstantService.getConstantList('MEETING_COMPANY_TYPE')}
                                        labelName='value'
                                        valueName='constantId'
                                        additionalValue1Name="additionalValue1"
                                    />
                                </div>
                            )
                        }
                    </Box>

                    <Box flexDirection="row" justifyContent="flex-end" p="15px">
                        <Box mr="15px">
                            <button className="btn btn-sm btn-light btn-active-light-primary" onClick={() => dispatch(storeFastFirm(undefined))}>Geri</button>
                        </Box>
                        <Box>
                            <button className="btn btn-primary btn-sm" onClick={isJustAddress ? saveCompanyAddress : saveCompany}>Kaydet</button>
                        </Box>
                    </Box>
                </Box>
            </Box>
        </div >
    )
}

FastFirm.defaultProps = {
    companyId: undefined,
    isCustomer: false,
    isSupplier: false,
    isAgency: false,
    isSenderFirm: false,
    isReceiverFirm: false,
    isDutyFirm: false,
    isAirlineFirm: false,
    isSeawayFirm: false,
    isCompany: false,
    isRepresentative: false,
    isJustAddress: false
}

export default FastFirm;